module.exports = __webpack_public_path__ + "static/media/hierarquia.da02d6aa.png";